<template>
  <div class="py-2 px-0 text-xs">
    <el-button
      id="collapse-button"
      size="mini"
      icon="el-icon-s-unfold"
      style="height: 40px;"
      class="mb-2"
      @click="setSidebarOpen(true)"
      v-if="!sidebarOpen"
      >Display Sensor List</el-button
    >
    <div
      class="w-full flex flex-col lg:flex-row space-x-0 space-y-2 lg:space-x-2 lg:space-y-0"
    >
      <div
        class="lg:w-1/3"
        :class="!sidebarOpen ? 'hidden' : ''"
        v-loading="loading"
      >
        <div class="border rounded-lg flex flex-col w-full h-full bg-white">
          <div
            class="h-12 bg-report-bell text-white w-full rounded-t-lg flex justify-between items-center px-4"
          >
            <h5 class="text-base font-bold">Sensors</h5>

            <el-tooltip
              class="item"
              effect="dark"
              content="Hide Sensor List"
              placement="top-start"
            >
              <div
                class="cursor-pointer border-white p-1"
                @click="setSidebarOpen(false)"
              >
                <i class="el-icon-close text-lg font-bold"></i>
              </div>
            </el-tooltip>
          </div>

          <div class="p-4">
            <div v-if="!this.$route.query.Id">
              <el-checkbox
                :indeterminate="isIndeterminate"
                label="SELECT ALL"
                @change="checkAllSensor"
              ></el-checkbox>
              <hr class="my-2" />
            </div>
            <div
              class="flex flex-col mt-4 max-h-screen overflow-y-auto"
              v-if="!this.$route.query.Id"
            >
              <!-- <div class="" v-for="(item, index) in sensorData" :key="index"> -->
              <el-checkbox-group
                v-model="checkedSensors"
                @change="itemsChecked"
              >
                <template v-for="(sensors, index) in grouppedSensorData">
                  <strong class="text-sm pb-4 text-blue-500">{{
                    index
                  }}</strong>
                  <div class="p-2">
                    <el-checkbox
                      v-for="item in sensors"
                      :label="item.DceSensorId"
                      :key="item.DceSensorId"
                      class="w-full"
                    >
                      {{ item.SensorName }}
                    </el-checkbox>
                  </div>
                </template>
              </el-checkbox-group>
            </div>
            <div
              class="flex space-x-0 space-y-4 lg:space-x-4 lg:space-y-0 flex-col text-sm max-h-screen overflow-y-scroll"
              v-if="this.$route.query.Id"
            >
              <div
                class="flex flex-col gap-1"
                v-for="(sensors, index) in grouppedSensorData"
              >
                <span>{{ index }}</span>
                <ul>
                  <template v-for="item in sensors">
                    <li>
                      <strong>
                        <i class="el-icon-magic-stick"></i>
                        {{ item.SensorName }}</strong
                      >
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full lg:w-2/3">
        <MainForm
          :sensor-data="sensorData"
          :groupped-sensor-data="grouppedSensorData"
          :checked-sensors="checkedSensors"
          @fetch-sensor-data="fetchSensorData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MainForm from '@/components/formula/MainForm'

export default {
  components: {
    MainForm
  },
  data() {
    return {
      checkedSensors: [],
      sensorData: [],
      grouppedSensorData: {},
      deviceDceIds: '',
      isIndeterminate: false,
      sidebarOpen: true
    }
  },
  mounted() {
    this.deviceDceIds = this.$route.query.deviceDceIds
    if (this.$route.query.deviceDceIds) {
      this.fetchSensorData()
    }
  },
  methods: {
    async fetchSensorData(data = null) {
      try {
        var deviceDceIds = this.$route.query.deviceDceIds
        var customerSensorIds = this.$route.query.customerSensorIds

        if (data) {
          deviceDceIds = data.deviceDceIds
          customerSensorIds = data.customerSensorIds
        }

        this.loading = true
        if (this.$route.query.Id) {
          var res = await this.$axios.get(
            this.$appInfo.api.formula.getListSensorFromFormula +
              '?Id=' +
              this.$route.query.Id
          )
        } else {
          var res = await this.$axios.post(
            this.$appInfo.api.treeGroupDevice.getListSensorByDevicePost,
            {
              DeviceDceId: deviceDceIds
            }
          )
        }

        this.sensorData = res.data.filter((x) =>
          customerSensorIds.includes(x.DceSensorId)
        )
        this.grouppedSensorData = this.groupByKey(
          this.sensorData,
          'DeviceDceName'
        )
        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },

    setSidebarOpen(val) {
      this.sidebarOpen = val
    },
    itemsChecked(value) {
      let checkedCount = value.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.sensorData.length
    },
    checkAllSensor(val) {
      this.isIndeterminate = false
      this.checkedSensors = val ? this.sensorData.map((x) => x.DceSensorId) : []
    },
    groupByKey(array, key) {
      return array.reduce((hash, obj) => {
        if (obj[key] === undefined) return hash
        return Object.assign(hash, {
          [obj[key]]: (hash[obj[key]] || []).concat(obj)
        })
      }, {})
    }
  }
}
</script>

<style>
.w-screen-xl {
  width: 1280px;
}
</style>
